import React from "react";
import SEOPage from "../Components/SEOPage";
import Navbar from "../Components/Navbar";
import ScrollReveal from "../Components/ScrollReveal";
import SiteFooter from "../Components/SiteFooter";
import Chatbox from "../Components/Chatbox";
import CmsHero from "../Components/cms/CmsHero";
import WhyChooseCms from "../Components/cms/WhyChooseCms";
import CmsPlatforms from "../Components/cms/CmsPlatforms";
import HowWeWork from "../Components/home/HowWeWork";
import TrustedIndustries from "../Components/home/TrustedIndustries";

// Redesigned (Tailwind) page for /service/cms-website-design-development-solutions.
const CmsWebsitePage = () => (
  <div>
    <SEOPage
      title="CMS Website Design & Development Company in Noida | DataMetricks"
      description="DataMetricks builds flexible, scalable and easy-to-manage CMS websites on WordPress, Shopify, Joomla, Drupal, Webflow and custom CMS, so you can update content without any technical expertise."
      canonicalUrl="https://www.datametricks.com/service/cms-website-design-development-solutions"
    />

    <Navbar />
    <ScrollReveal />

    {/* Every Tailwind utility is scoped to `.tw` (see tailwind.config.js) */}
    <main className="tw">
      <CmsHero />
      <WhyChooseCms />
      <CmsPlatforms />
      <HowWeWork />
      <TrustedIndustries />

    </main>

    <Chatbox />
    <SiteFooter />
  </div>
);

export default CmsWebsitePage;
